export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "Enviado com sucesso",
      error: "Erro no envio",
      notConfigured: "Não configurado",
      pending: "Envio pendente",
    },
    errorNoInfo: "Erro (sem detalhes)",
  },
  msgPolice: {
    title: "Informação",
    pendingSyncText:
      "Os dados do check-in estão pendentes de sincronização; serão enviados às autoridades locais no mesmo dia em que o hóspede chegar à acomodação.",
    entryDateLabel: "Data de chegada:",
    syncedText:
      "Os dados do hóspede {name} foram sincronizados com as autoridades locais com sucesso.",
    syncDateLabel: "Data de sincronização:",
    errorText:
      "Por motivos externos, não foi possível concluir a sincronização com as autoridades locais.",
    close: "Fechar",
  },
};
